/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_Group_HelpInputs */

const en_linked_group_help = /** @type {(inputs: Linked_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The linked group is used to populate the source events for translation.`)
};

const fr_linked_group_help = /** @type {(inputs: Linked_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le groupe lié sert à remplir les événements source pour la traduction.`)
};

const de_linked_group_help = /** @type {(inputs: Linked_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die verknüpfte Gruppe dient dazu, die Quellereignisse für die Übersetzung zu füllen.`)
};

const it_linked_group_help = /** @type {(inputs: Linked_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gruppo collegato viene utilizzato per popolare gli eventi sorgente per la traduzione.`)
};

const ru_linked_group_help = /** @type {(inputs: Linked_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связанная группа используется для заполнения исходных событий для перевода.`)
};

const es_linked_group_help = /** @type {(inputs: Linked_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El grupo vinculado se utiliza para completar los eventos de origen para la traducción.`)
};

const zh_cn2_linked_group_help = /** @type {(inputs: Linked_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接组用于填充要翻译的源事件。`)
};

const ja_linked_group_help = /** @type {(inputs: Linked_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクされたグループは、翻訳のソース イベントを入力するために使用されます。`)
};

const hi_linked_group_help = /** @type {(inputs: Linked_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंक्ड ग्रुप का उपयोग अनुवाद के लिए स्रोत घटनाओं को भरने के लिए किया जाता है।`)
};

const pt_pt2_linked_group_help = /** @type {(inputs: Linked_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grupo vinculado é usado para preencher os eventos de origem para tradução.`)
};

/**
* | output |
* | --- |
* | "The linked group is used to populate the source events for translation." |
*
* @param {Linked_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const linked_group_help = /** @type {((inputs?: Linked_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_linked_group_help(inputs)
	if (locale === "de") return de_linked_group_help(inputs)
	if (locale === "it") return it_linked_group_help(inputs)
	if (locale === "ru") return ru_linked_group_help(inputs)
	if (locale === "es") return es_linked_group_help(inputs)
	if (locale === "zh-CN") return zh_cn2_linked_group_help(inputs)
	if (locale === "ja") return ja_linked_group_help(inputs)
	if (locale === "hi") return hi_linked_group_help(inputs)
	if (locale === "pt-PT") return pt_pt2_linked_group_help(inputs)
	return en_linked_group_help(inputs)
});